import deCustomer from './de/customer.json';

export default {
  de: {
    customer: deCustomer,
  },
};
